export { default as About } from "./about";
export { default as PartnerWithUs } from "./partner-with-us";
export { default as GetInsurance } from "./get-insurance";
export { default as NotFound } from "./not-found";
export { default as Partner } from "./partners";
export { default as Venue } from "./venues";
export { default as Weddings } from "./weddings";
